/** @jsx jsx */
import { any, string } from 'prop-types'
import { useState } from 'react'
import { jsx, Flex, Text, IconButton } from 'theme-ui'
import { Link } from 'gatsby'
import {
  BrandLogoMobile,
  Close,
  Menu,
  Profile,
  Search,
} from '../../icons/index'
import Modal from '../common/Modal'
import NavList from './NavList'
import NavLink from './NavLink'

const MobileNavigationMenu = ({ userInitials, navList }) => {
  const [mobileNavVisible, setMobileNavVisible] = useState(false)
  return (
    <Flex sx={{ alignItems: 'center' }}>
      {/* Add search icon to main nav bar */}
      <NavLink
        to="app/ResourceSearch"
        sx={{
          display: 'flex',
          alignItems: 'center',
          ml: 2,
          '&:hover div': {
            color: 'citron',
          },
          '&:hover svg': {
            fill: 'citron',
          },
        }}
      >
        <Search height={24} color="white" sx={{ mr: 1 }} />
      </NavLink>
      <IconButton
        aria-label="open navigation"
        onClick={() => setMobileNavVisible(true)}
      >
        <Menu color="white" />
      </IconButton>
      <Modal
        label="mobile navigation"
        handleDismiss={() => setMobileNavVisible(false)}
        isOpen={mobileNavVisible}
        sx={{
          position: ['absolute', 'absolute', 'static'],
          top: [0],
          left: 0,
          right: 0,
          bottom: 0,
          width: ['100%', '100%', '100%'],
          maxWidth: 1000,
          margin: 0,
          p: 0,
          bg: 'forest',
        }}
      >
        <Flex
          aria-label="mobile navigation"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'primary',
          }}
        >
          <Flex
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center',
              height: '44px',
            }}
          >
            <Flex>
              <Link
                aria-label="home"
                to="/"
                onClick={() => setMobileNavVisible(false)}
                sx={{
                  display: 'flex',
                  ml: 5,
                }}
              >
                <BrandLogoMobile alt="Commonwealth Logo" />
              </Link>
            </Flex>
            <Flex>
              {/* Search icon removed from hamburger menu */}
              {/* User initials removed from hamburger menu */}
              <Link // placeholder until feature is planned
                to="/"
                aria-label="account"
                sx={{
                  display: 'none', // Hide user initials in hamburger menu
                  alignItems: 'center',
                  pointerEvents: 'none',
                  mr: 6,
                  textDecoration: 'none',
                }}
              >
                <Profile color="white" sx={{ mr: 2 }} />
                <Text sx={{ color: 'white', textTransform: 'uppercase' }}>
                  {userInitials}
                </Text>
              </Link>
              <IconButton
                aria-label="close navigation"
                sx={{ mr: 5 }}
                onClick={() => setMobileNavVisible(false)}
              >
                <Close color="white" />
              </IconButton>
            </Flex>
          </Flex>
          <Flex sx={{ flexDirection: 'column', ml: 0, mt: 6 }}>
            <NavList
              navList={navList}
              closeMobileModal={() => setMobileNavVisible(false)}
            />
          </Flex>
        </Flex>
      </Modal>
    </Flex>
  )
}

MobileNavigationMenu.propTypes = {
  userInitials: string,
  navList: any.isRequired,
}

export default MobileNavigationMenu
